
/* eslint-disable import/prefer-default-export */
export const EMERGENCY_LABELS = {
  TEMPERATURE_ALARM: "Alarme Temperatura",
  JAMMING_DETECTED: "Jamming detectado",
  BEACON: "Ancoragem rompida",
  PANIC_BUTTON: "Pânico Motorista",
  MOVEMENT_SENSOR: "Sensor movimento",
  BOX_VIOLATION: "Pânico Carona",
  NO_BATTERY: "Sem bateria",
  PANIC_PASSENGER: "Pânico Passageiro",
  PANIC_BAG: "Pânico Porta-Malas",
  EMERGENCY_MODE: "Modo de Emergência"
};

export function getEmergencyLabel (equipment) {
  const eqEvent = equipment.lastEventEquipment || equipment.lastEvent;

  if (eqEvent && eqEvent.status && eqEvent.status.jammingDetected) return 'Jammer Detectado';

  if (eqEvent && eqEvent.status && eqEvent.status.movementSensorAlarm) return 'Alarme de Movimento';

  if (eqEvent && eqEvent.status && eqEvent.status.temperatureAlarm) return 'Alarme de Temperatura';

  if (eqEvent && eqEvent.status && eqEvent.status.snifferMode) return 'Modo de Emergência';

  return EMERGENCY_LABELS[equipment.emergencyType];
}
